import { render, staticRenderFns } from "./StandbyReleaseSection.vue?vue&type=template&id=704ec6e0&scoped=true"
import script from "./StandbyReleaseSection.vue?vue&type=script&lang=ts"
export * from "./StandbyReleaseSection.vue?vue&type=script&lang=ts"
import style0 from "./StandbyReleaseSection.vue?vue&type=style&index=0&id=704ec6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ec6e0",
  null
  
)

export default component.exports